import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import SettingsForm from "../../SettingsForm";
import Wrapper from "../../../../components/UI/common/Wrapper";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import ButtonSet from "../../../../components/UI/ButtonSet";
import NumberUnit from "../../../../components/UI/NumberUnit";
import ColorPicker from "../../../../components/UI/ColorPicker";

export default function ButtonSettings() {
    const { settings, getSection, getOption, handleInputChange } =
        useSettingsContext();

    const sectionID = "icon";
    const section = getSection(sectionID);

    // console.log(settings);

    return (
        <SettingsForm
            title={__(
                "Icons Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Customize quantity increment and decrement icons.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <FieldWrapper
                label={__(
                    "Icons Type",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Set the quantity increment and decrement icons type.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                width="160"
                containerClass=""
                fieldsClass=""
                direction="vertical"
            >
                <ButtonSet
                    name="iconsType"
                    value={getOption("iconsType", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                    options={[
                        {
                            value: "plus_minus",
                            label: __(
                                "Plus/Minus",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "arrows",
                            label: __(
                                "Arrows",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "chevrons",
                            label: __(
                                "Chevrons",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                    ]}
                />
            </FieldWrapper>

            <Wrapper
                title={__(
                    "Size Settings",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity icons style settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Width",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus & minus icons area width.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("iconAreaWidth", sectionID)}
                            onChange={(value) =>
                                handleInputChange(
                                    section,
                                    "iconAreaWidth",
                                    value,
                                )
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Height",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus & minus icons area height.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("iconAreaHeight", sectionID)}
                            onChange={(value) =>
                                handleInputChange(
                                    section,
                                    "iconAreaHeight",
                                    value,
                                )
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Icon Size",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Set the quantity increment and decrement SVG icons size.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("iconsSize", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "iconsSize", value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
            <Wrapper
                title={__(
                    "Color Settings",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity icons background & color settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus/minus icon color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconColor"
                            value={getOption("iconColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>

                    <FieldWrapper
                        label={__(
                            "Hover Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus/minus icon hover color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconHoverColor"
                            value={getOption("iconHoverColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Background",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus/minus icon background color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconBg"
                            value={getOption("iconBg", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>

                    <FieldWrapper
                        label={__(
                            "Hover Background",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity plus/minus icon hover background color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconHoverBg"
                            value={getOption("iconHoverBg", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
            <Wrapper
                title={__(
                    "Border Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity buttons border settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Width",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity increment and decrement icons border width can be adjusted here.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("iconsBorderWidth", sectionID)}
                            onChange={(value) =>
                                handleInputChange(
                                    section,
                                    "iconsBorderWidth",
                                    value,
                                )
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Radius",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Set the quantity increment and decrement icons border radius.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("iconsRadius", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "iconsRadius", value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Set the quantity increment and decrement icons border color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconsBorderColor"
                            value={getOption("iconsBorderColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Hover Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Set the quantity increment and decrement icons hover border color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="iconsBorderHoverColor"
                            value={getOption(
                                "iconsBorderHoverColor",
                                sectionID,
                            )}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
        </SettingsForm>
    );
}
